export default "<svg>\n  <g>\n    <text class=\"caption animate__animated animate__jackInTheBox\">\n      CHEERS!\n    </text>\n  </g>\n</svg>";